export default __webpack_public_path__ + "static/media/work2.fe10419c.png";